@let title = text(textMode ? 'no-video' : null);
@if (title) {
  <div #label id="{{ question.id }}-label-content"
       class="field-label video-question"
       [innerHTML]="title"></div>
}
<form-control-info [id]="question.id!" [items]="infoMessages"></form-control-info>

@if (baseForm.interviewState()?.errors?.validations) {
  <div class="alert alert-warning warning pill form-warning-list row my-3" [attr.aria-live]="'assertive'">
    <i class="fa fa-info-circle col-1 my-auto" aria-hidden="true"></i>
    <ul class="col-10 my-3 mx-3">
      @for (validation of baseForm.interviewState()?.errors?.validations | keyvalue; track $index) {
        <li>{{ validation.value }}</li>
      }
    </ul>
  </div>
}
@if (stage === VideoStage.COMPLETE && baseForm.interviewState()?.currentQuestion?.userResponse) {
  <div class="alert alert-dark transcript-text-alert rounded-sm row my-3" [attr.aria-live]="'assertive'">
    <i class="fa fa-keyboard-o col-1 my-auto" aria-hidden="true"></i>
    <ul class="col-11 my-3">
      <li>{{ messages.getText("WILL.help.edit-transcribed") }}</li>
      <li>
          <textarea #input [attr.type]="inputType"
                    [attr.name]="question.id"
                    [attr.id]="question.id"
                    class="form-control {{inputClass}}"
                    [attr.autocomplete]="determineAutocompleteValue(question.id!)"
                    [required]="question.required!" [attr.aria-required]="question.required"
                    [attr.aria-invalid]="controlHasError()"
                    [formControl]="control | asFormControl"
                    (blur)="revalidateInput()"
                    (input)="onValueChange($event);revalidateInput()"
                    [attr.aria-labelledby]="getAriaLabels('label')"
                    [attr.aria-label]="getLabel()">
          </textarea>
      </li>
    </ul>
  </div>
}

<div>
  @if (textMode) {
    <textarea #input [attr.type]="inputType"
              [attr.name]="question.id"
              [attr.id]="question.id"
              class="form-control {{inputClass}}"
              [attr.autocomplete]="determineAutocompleteValue(question.id!)"
              [required]="question.required!" [attr.aria-required]="question.required"
              [attr.aria-invalid]="controlHasError()"
              [formControl]="control | asFormControl"
              (blur)="revalidateInput()"
              (input)="onValueChange($event);revalidateInput()"
              [attr.aria-labelledby]="getAriaLabels('label')"
              [attr.aria-label]="getLabel()"
              [ngClass]="{ 'is-invalid': controlHasError() }"
              placeholder="{{ messages.getText('WILL.text.placeholder') }}">
    </textarea>
  } @else {
    <div class="row align-items-center">
<!-- ToDo :: Test removing these (wrap in @if) rather than hiding them -->
      <video class="video mt-1" [hidden]="stage !== VideoStage.RECORDING && stage !== VideoStage.PAUSED" #video autoplay></video>
      <div class="video-time mb-1 mx-1 pl-2 py-1" [hidden]="stage !== VideoStage.RECORDING && stage !== VideoStage.PAUSED">
        {{ messages.getText("WILL.help.video.time-left") }}{{ timeLeft * 1000 | date:'mm:ss' }}
      </div>
      <video class="video m-1" [hidden]="stage === VideoStage.RECORDING || stage !== VideoStage.COMPLETE" #recordedVideo controls></video>
    </div>
  }
  @if (!!control.validator && (control.touched || baseForm.isSubmitted()) && textMode) {
    <div #feedback
         class="feedback-icon" [class.no-video]="textMode" aria-hidden="true">
      <i class="fa" aria-hidden="true"
         [ngClass]="{ 'fa-check-circle' : !controlHasError() || stage === VideoStage.COMPLETE, 'fa-times-circle' : controlHasError() && !stage }"></i>
    </div>
  }
  <div class="option-row row align-items-center mt-4 mx-0">
    <div class="px-0 text-end">
      @if (stage !== VideoStage.RECORDING && stage !== VideoStage.PAUSED && stage !== VideoStage.SAVING && stage !== VideoStage.FAILED_TO_UPLOAD && !textMode) {
        <button
          class="btn primary rounded-pill submit mt-3 ms-3"
          [disabled]="stage === VideoStage.LOADING || textMode"
          (click)="startRecording()">
          @if (stage === VideoStage.LOADING) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ messages.getText("WILL.help.video.start") }}
        </button>
      }
      @if (stage === VideoStage.PAUSED) {
        <button class="btn secondary rounded-pill submit mt-3 ms-3" (click)="playPauseRecording()">
          {{ messages.getText("WILL.help.video.resume") }}
        </button>
      }
      @if (stage === VideoStage.RECORDING) {
        <button class="btn secondary rounded-pill submit mt-3 ms-3" (click)="playPauseRecording()">
          {{ messages.getText("WILL.help.video.pause") }}
        </button>
        <button class="btn primary rounded-pill submit mt-3 ms-3" (click)="stopRecording()">
          {{ messages.getText("WILL.help.video.stop") }}
        </button>
      }
      @if (stage === VideoStage.SAVING) {
        <button class="btn primary rounded-pill submit mt-3 ms-3" disabled>
          <span class="spinner-border spinner-border-sm mr-1"></span>
          {{ messages.getText("WILL.help.video.wait") }}
        </button>
      }
      @if (stage === VideoStage.FAILED_TO_UPLOAD) {
        <button class="btn primary rounded-pill submit mt-3 ms-3" (click)="onStopRecordingEvent()">
          @if (baseForm.loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ messages.getText("WILL.help.video.retry-upload") }}
        </button>
      }
      @if (stage !== VideoStage.RECORDING && stage !== VideoStage.SAVING && stage !== VideoStage.LOADING) {
        <button class="btn secondary rounded-pill submit mt-3 ms-3" (click)="toggleVideoMode()">
          @if (baseForm.loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          @if (textMode) {
            {{ messages.getText("WILL.help.video.switch-to-video") }}
          } @else {
            {{ messages.getText("WILL.help.video.switch-to-text") }}
          }
        </button>
      }

      @if (stage === VideoStage.COMPLETE || textMode) {
        <button class="btn primary rounded-pill submit mt-3 ms-3"
                [disabled]="baseForm.loading || baseForm.preventSave"
                [attr.aria-label]="getLabel() + '.save_button'"
                (click)="onEnter($event)"
                (keydown.enter)="onEnter($event)">
          @if (baseForm.loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ messages.getText('WILL.button.save-and-continue') }}
        </button>
      }
    </div>
  </div>

</div>

<ng-content></ng-content>
